jQuery(function() {
//IE11 Detection
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
    document.documentElement.classList.add('IE11');

    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach
    if (window.HTMLCollection && !HTMLCollection.prototype.forEach) HTMLCollection.prototype.forEach = Array.prototype.forEach

    if (!Array.from) { Array.from = (function () { var toStr = Object.prototype.toString; var isCallable = function (fn) { return typeof fn === 'function' || toStr.call(fn) === '[object Function]'; }; var toInteger = function (value) { var number = Number(value); if (isNaN(number)) { return 0; } if (number === 0 || !isFinite(number)) { return number; } return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number)); }; var maxSafeInteger = Math.pow(2, 53) - 1; var toLength = function (value) { var len = toInteger(value); return Math.min(Math.max(len, 0), maxSafeInteger); }; return function from(arrayLike/*, mapFn, thisArg */) { var C = this; var items = Object(arrayLike); if (arrayLike == null) { throw new TypeError("Array.from requires an array-like object - not null or undefined"); } var mapFn = arguments.length > 1 ? arguments[1] : void undefined; var T; if (typeof mapFn !== 'undefined') { if (!isCallable(mapFn)) { throw new TypeError('Array.from: when provided, the second argument must be a function'); } if (arguments.length > 2) { T = arguments[2]; } } var len = toLength(items.length); var A = isCallable(C) ? Object(new C(len)) : new Array(len); var k = 0; var kValue; while (k < len) { kValue = items[k]; if (mapFn) { A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k); } else { A[k] = kValue; } k += 1; } A.length = len; return A; }; }()); }
}


    //Product Page Item description collapse and tabs
    $(function () {
        const $tabLinksWrap = $('#tabs > .tab-buttons');
        const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);
    
        $("#tabs > div").hide();
        $("#tabs > div:first").show();
        $tabFirstBtn.addClass('active');
            
        $tabLinksWrap.on('click', 'button', function () {
    
            const $this = $(this);
            const $sibling = $this.siblings();
        
            $sibling.removeClass('active').attr({
                'tabindex': '-1',
                'aria-selected': 'false'
            });
        
            $this.addClass('active').attr({
                'tabindex': '0',
                'aria-selected': 'true'
            });
        
            var currentTab = $this.attr('aria-controls');
            $("#tabs > div").hide();
            $(`#${currentTab}`).show();
        
            return false;
        });
    });

    $(window).on('load', function () {
        $('.item-image, .slider').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });

    if (document.body.classList.contains("pghome")) {
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {

            } else {

            }
        }

        checkWidth();
        window.addEventListener("resize", function(){
            checkWidth();
        });
    }

       /* ADA AAA
    Main navigation menu */
    $(function () {
        var $dropdowns = $("#main-nav .dropdown");
        var $dropdownsLinks = $("#main-nav .dropdownLink");
        $dropdownsLinks.on("focus",function(){
          let $thisParent = $(this).parent();
          $dropdowns.removeClass("open");
          $dropdownsLinks.attr("aria-expanded", "false");
          $thisParent.addClass("open");
          $(this).attr("aria-expanded", "true");
        })
    
        $('#main-nav').on("focusout", function() {
            setTimeout(() => {
              // if active element is outside the div.header-container...
              if ($(document.activeElement).parents('#main-nav').length === 0) {
                // remove hover functionality
                $dropdowns.removeClass("open");
                $dropdownsLinks.attr("aria-expanded", "false");
              }
            }, 100);
        })
    }); 
});
